import { Controller } from "@hotwired/stimulus"

// Handles file selection (picker, or files handed over by file-drop) and creates upload items
// Each upload item gets its own direct_upload controller
export default class extends Controller {
  static targets = ["input", "pendingUploads", "template"]
  static values = { url: String, folderId: Number }

  open() {
    this.inputTarget.click()
  }

  selectFiles(event) {
    Array.from(event.target.files).forEach(file => this.uploadFile(file))
    event.target.value = ''
  }

  dropFiles({ detail: { files } }) {
    files.forEach(file => this.uploadFile(file))
  }

  uploadFile(file) {
    const tempId = `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`

    // Clone template for upload item (empty:hidden CSS handles container visibility)
    const item = this.templateTarget.content.cloneNode(true).firstElementChild

    // Pass folder ID to the direct_upload controller if set
    if (this.hasFolderIdValue) {
      item.dataset.directUploadFolderIdValue = this.folderIdValue
    }

    this.pendingUploadsTarget.prepend(item)

    // Wait for Stimulus to initialize the controller on the new element
    this.waitForController(item, 'direct-upload').then(controller => {
      controller.start(file, tempId)
    })
  }

  waitForController(element, identifier, maxAttempts = 10) {
    return new Promise((resolve, reject) => {
      let attempts = 0
      const check = () => {
        const controller = this.application.getControllerForElementAndIdentifier(element, identifier)
        if (controller) {
          resolve(controller)
        } else if (attempts < maxAttempts) {
          attempts++
          requestAnimationFrame(check)
        } else {
          reject(new Error(`Controller ${identifier} not found after ${maxAttempts} attempts`))
        }
      }
      check()
    })
  }
}
